export default __webpack_public_path__ + "static/media/element_78.338832e6.webp";